// store/balance/createBalanceSlice.ts

import { StateCreator } from 'zustand';
import { AxeResponseDto, TagResponseDto, TagsQueryParams } from '../../types';
import { tagsInitialState, TagsState } from './tagsInitialState';
import { createFunctionalSetter } from '../storeCommons';

/**
 * @french
 * Interface des actions liées à la balance.
 */
export interface TagsActions {
  setTagsQueryParams: (tagsQueryParams: TagsQueryParams) => void;
  setSelectedAxe: (selectedAxe: AxeResponseDto | undefined) => void;
  setSelectedTag: (selectedTag: TagResponseDto | undefined) => void;
  reset: () => void;
}

/**
 * @french
 * Slice Zustand pour les actions de la balance.
 */
export const createTagsSlice: StateCreator<TagsState & TagsActions, [], [], TagsActions> = (
  set,
  get,
) => ({
  setTagsQueryParams: createFunctionalSetter(get, set, 'tagsQueryParams'),
  setSelectedAxe: createFunctionalSetter(get, set, 'selectedAxe'),
  setSelectedTag: createFunctionalSetter(get, set, 'selectedTag'),
  reset: () => set(tagsInitialState),
});
